import React, { useState, useRef } from 'react'
import SelectDropdown from 'modules/projects/components/SelectDropdown'
import {
  MobileContainer,
  MobileNavigationLink,
  MobileNavigationHeader,
  MobileSearchContainer,
  MobileSearchButton,
  MobileSearch,
} from './Header.styles'
import { isCwvSpecificRoute } from 'modules/shares/ComponentsWebView/CwvRoutes'
import { LoupeIcon } from 'components/Filter/Filter.styles'
import useOnClickOutside from 'utils/hooks/useOnClickOutside'

export const MobileHeader: React.FC<{
  shareID: string
  path: string
  versionShortId: string
  setSearchCwv: (search: string) => void
  isSidebarRightOpen: boolean
}> = ({ shareID, path, versionShortId, setSearchCwv, isSidebarRightOpen }) => {
  const [isSearchVisible, setIsSearchVisible] = useState(false)
  const searchRef = useRef<HTMLElement>(null)

  const links = {
    SHARE_VIEW: 'Pages',
    CWV_SYMBOLS: 'Symbols',
    CWV_LAYER_STYLES: 'Layer Styles',
    CWV_TEXT_STYLES: 'Text Styles',
    CWV_COLOR_VARIABLES: 'Color Variables',
  }

  const getCurrentRoute = (): string => {
    if (isCwvSpecificRoute(path, 'SHARE_VIEW')) {
      return links.SHARE_VIEW
    }
    if (isCwvSpecificRoute(path, 'CWV_SYMBOLS')) {
      return links.CWV_SYMBOLS
    }
    if (isCwvSpecificRoute(path, 'CWV_LAYER_STYLES')) {
      return links.CWV_LAYER_STYLES
    }
    if (isCwvSpecificRoute(path, 'CWV_TEXT_STYLES')) {
      return links.CWV_TEXT_STYLES
    }

    return links.CWV_COLOR_VARIABLES
  }

  const getRouteKey = (link: string) => {
    switch (link) {
      case 'Pages':
        return 'SHARE_VIEW'
      case 'Symbols':
        return 'CWV_SYMBOLS'
      case 'Layer Styles':
        return 'CWV_LAYER_STYLES'
      case 'Text Styles':
        return 'CWV_TEXT_STYLES'
      default:
        return 'CWV_COLOR_VARIABLES'
    }
  }

  const closeSearch = () => setIsSearchVisible(false)

  const handleSearchClick = () => {
    const toggleSearch = !isSearchVisible
    setIsSearchVisible(toggleSearch)

    const searchInput = document.querySelector(
      '[data-cwv-search-input]'
    ) as HTMLElement

    // setTimeout is needed, otherwise the focus never happens
    setTimeout(() => {
      toggleSearch ? searchInput?.focus() : searchInput?.blur()
    }, 0)
  }

  useOnClickOutside(searchRef, closeSearch)

  return (
    <MobileContainer
      pt={2}
      pl={3}
      pb={2}
      isSidebarRightOpen={isSidebarRightOpen}>
      <MobileSearchContainer isSearchVisible={isSearchVisible} ref={searchRef}>
        <MobileSearchButton
          icon={LoupeIcon}
          small
          onClick={handleSearchClick}
          isSearchVisible={isSearchVisible}
        />
        <MobileSearch
          isCWV
          isSearchVisible={isSearchVisible}
          placeholder="Search Components"
          onChange={setSearchCwv}
        />
      </MobileSearchContainer>
      <SelectDropdown
        headerItem={<MobileNavigationHeader>View</MobileNavigationHeader>}
        placeholder={links.SHARE_VIEW}
        items={Object.values(links)}
        value={getCurrentRoute()}
        renderItem={item => (
          <MobileNavigationLink
            selected={isCwvSpecificRoute(path, getRouteKey(item))}
            to={{
              routeKey: getRouteKey(item),
              routeParams: {
                shareID,
                versionShortId,
              },
            }}>
            {item}
          </MobileNavigationLink>
        )}
      />
    </MobileContainer>
  )
}
